var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.existClient
        ? _c(
            "b-button",
            {
              attrs: { size: "sm", variant: "info" },
              on: { click: _vm.openClientInfoModal }
            },
            [_vm._v("\n    Профиль\n  ")]
          )
        : _vm.clientSetted
        ? _c(
            "b-button",
            {
              attrs: { size: "sm", variant: "success" },
              on: { click: _vm.createClientProfile }
            },
            [_vm._v("\n    Создать профиль\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("create-client-profile", { ref: "create-client" }),
      _vm._v(" "),
      _c(
        "client-card",
        _vm._b(
          {
            ref: "clientCard",
            on: {
              "update:client-order": function($event) {
                return _vm.$emit("update:client-order", $event)
              }
            }
          },
          "client-card",
          _vm.clientIdent,
          false
        )
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-be695ed0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be695ed0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/containers/ClientInfoWithOpenButton.vue
// module id = null
// module chunks = 